// Call Partnerships
import { apiAuth } from '../../utils/hooks';

const patchAccount = (accountId, updatedAccount) => {
    return apiAuth()
        .patch(`/account/${accountId}`, updatedAccount)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getBilling = (accountId, space, params) => {
    return apiAuth()
        .get(`/account/${accountId}/invoices/${space}`, {
            params: params,
        })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchMyUser = (updatedUser) => {
    return apiAuth()
        .patch('/account/me/user/me', updatedUser)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const putAssociation = (idAssociation, updatedCharity) => {
    return apiAuth()
        .put(`/association/${idAssociation}`, updatedCharity)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAccountAddress = (accountId) => {
    return apiAuth()
        .get(`/account/${accountId}/postalAddress/default`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export {
    patchAccount,
    patchMyUser,
    getBilling,
    putAssociation,
    getAccountAddress,
};
